(function () {
  'use strict';

  function initCollectionsListSlider(section) {
    if (typeof Swiper === 'undefined') return;

    var el = section.querySelector('[data-collections-swiper]');
    if (!el || el.swiper || el.dataset.initSlider !== 'true') return;

    var slidesMobile = parseInt(el.dataset.slidesMobile, 10) || 1;
    var slidesTablet = parseInt(el.dataset.slidesTablet, 10) || 2;
    var slidesDesktop = parseInt(el.dataset.slidesDesktop, 10) || 3;
    var spaceBetween = parseInt(el.dataset.spaceBetween, 10) || 30;
    var showPagination = el.dataset.pagination === 'true';

    new Swiper(el, {
      slidesPerView: slidesDesktop,
      spaceBetween: spaceBetween,
      pagination: showPagination
        ? {
            el: section.querySelector('[data-collections-pagination]'),
            clickable: true
          }
        : false,
      breakpoints: {
        0: { slidesPerView: slidesMobile },
        768: { slidesPerView: slidesTablet },
        1024: { slidesPerView: slidesDesktop }
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.shopify-section--collections-list').forEach(initCollectionsListSlider);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('shopify-section--collections-list')) {
      initCollectionsListSlider(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('[data-collections-swiper]');
    if (el && el.swiper) el.swiper.destroy(true, true);
  });
})();
